import { Box, Flex, Text } from "@chakra-ui/react";

import { RelatedCompanyDto } from "@/api/usersApi";
import { useCallback, useEffect } from "react";
import { TruncatedText } from "@/components/TruncatedText";
import { t } from "i18next";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@digital-services-gard-as/anchor-react";
import { PencilIcon, CloseIcon } from "@digital-services-gard-as/anchor-icons";

type BranchCompanyProps = {
    selectedBranch: RelatedCompanyDto | null;
    setSelectedBranch: (branch: RelatedCompanyDto | null) => void;
    onOpenBranchModal: () => void;
};

const BranchCompanyButton = ({ selectedBranch, setSelectedBranch, onOpenBranchModal }: BranchCompanyProps) => {
    const queryClient = useQueryClient();

    useEffect(() => {
        const selectedBranchSessionStorage = globalThis.sessionStorage.getItem("selectedBranch");
        if (selectedBranch === null && selectedBranchSessionStorage !== null) {
            setSelectedBranch(JSON.parse(selectedBranchSessionStorage));
        }
    }, [selectedBranch, setSelectedBranch]);

    const handleClearBranchCompany = useCallback(() => {
        setSelectedBranch(null);
        globalThis.sessionStorage.removeItem("selectedBranch");
        queryClient.invalidateQueries({
            queryKey: ["claimsByCompanyId"]
        });
    }, [setSelectedBranch, queryClient]);

    return (
        <Box>
            <Flex>
                <Text asChild>
                    <b>{t("claimsInvoicesOverview:branchCompanyModal.description")}</b>
                </Text>
            </Flex>
            {selectedBranch ? (
                <Flex
                    bg="anchor.brown.50"
                    p="0.7rem"
                    alignItems="center"
                    justifyContent="space-between"
                    w="18rem"
                    border="solid 1px"
                    borderColor="anchor.brown.200"
                    borderRadius="5px"
                >
                    <Flex maxW="75%">
                        <TruncatedText text={selectedBranch.companyName} />
                    </Flex>
                    <Flex gap={1}>
                        <Button
                            size="sm"
                            variant="icon-only"
                            icon={<PencilIcon />}
                            aria-label={t("claimsInvoicesOverview:ariaLabels.editBranchCompany")}
                            onClick={onOpenBranchModal}
                            style={{ fontSize: "1.2rem" }}
                        />
                        <Button
                            size="sm"
                            variant="icon-only"
                            icon={<CloseIcon />}
                            style={{ fontSize: "1.2rem" }}
                            aria-label={t("claimsInvoicesOverview:ariaLabels.clearBranchCompany")}
                            onClick={handleClearBranchCompany}
                        />
                    </Flex>
                </Flex>
            ) : (
                <Flex>
                    <Button data-testid="branchModalBtn" onClick={onOpenBranchModal}>
                        {t("claimsInvoicesOverview:branchCompanyModal.selectBranchButton")}
                    </Button>
                </Flex>
            )}
        </Box>
    );
};

export default BranchCompanyButton;
